import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setOrderInitialState, setOriginalEditableOrder } from "../pages/orderPipeline/orderForm/orderFormSlice";
import { setProgressBarInitialState } from "../features/mainProgressBar/mainProgressBarSlice";
import { setDeliveryOptionInitialState } from "../pages/orderPipeline/deliveryOptions/deliveryOptionSlice";
import { setRecommendedServicesInitialState } from "../pages/orderPipeline/recommendedServices/recommendedServicesSlice";
import { clearOrderFromLocalStorage } from "../services/order/orderPersistence";

export const useClearingOrder = () => {
    const dispatch = useDispatch();

    const clearOrder = useCallback(() => {
        dispatch(setDeliveryOptionInitialState());
        dispatch(setProgressBarInitialState());
        dispatch(setOrderInitialState());
        dispatch(setRecommendedServicesInitialState());
        dispatch(setOriginalEditableOrder(undefined));
        clearOrderFromLocalStorage();
    }, [dispatch]);

    return [clearOrder];
};
